<template>
  <div class="default_page">
<!--    <el-row class="container">-->
<!--      <el-col :span="24">-->
      <div class="left_nav" :class="{'not_collapse': !isCollapse}">
        <div class="center top_nav">
          <span class="company_name">{{companyInfo.name}}</span>
          <span class="def_title" v-if="!isCollapse">{{$t('common.appTitle')}}</span>
        </div>
        <div class="left_bottom_navs">
          <left-menu ref="left_menu" :isCollapse="isCollapse"></left-menu>
        </div>
      </div>
      <div class="right_content">
        <section solt="rightContent" class="content-container" :class="$route.name==='2102' ? 'changebackground':''">
          <div class="grid-content bg-purple-light">
            <el-col :span="24" class="breadcrumb-container flex_between" v-if="$route.name!== '2102'">
              <div class="flex_vertical" style="width: 100%;">
                <i @click="isCollapse = !isCollapse" class="pointer leftBarBtn" :class="{'el-icon-s-fold': !isCollapse, 'el-icon-s-unfold': isCollapse}"></i>
                <el-breadcrumb separator="/" class="breadcrumb-inner">
                  <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                    {{$t(`menu.${item.meta.title}`)}}
                  </el-breadcrumb-item>
                </el-breadcrumb>
                <div style="flex: 1;"></div>
                <el-dropdown @command="onUserCommand">
                  <div class="flex_vertical" style="padding-right: 10px;">
                    <span style="padding-right: 10px;">{{user.username}}</span>
                    <el-avatar style="user-select: none;" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
            <el-col :span="24" class="content-wrapper">
              <transition name="fade" mode="out-in">
                <router-view></router-view>
                <slot name="not_children"></slot>
              </transition>
            </el-col>
          </div>
        </section>
      </div>
<!--      </el-col>-->
<!--    </el-row>-->
  </div>
</template>

<script>
  import leftMenu from './menu/leftMenu';
  export default {
    components: {
      leftMenu,
    },
    data() {
      return {
        isCollapse: false,
        user: {
          username: ''
        },
        loading: null,
        matched: [],
      }
    },
    computed: {
      submitting() {
        return this.$store.state.submitting;
      },
      submitText() {
        return this.$store.state.submitText;
      },
      companyInfo() {
        return this.$store.state.companyInfo;
      }
    },
    watch: {
      submitting(val) {
        if (val) {
          this.openLoading();
        } else {
          this.closeLoading();
        }
      }
    },
    mounted() {
      this.matched = this.$route.matched;
      const userString = sessionStorage.getItem('user');
      if (userString) {
        this.user = JSON.parse(userString);
      }
    },
    methods: {
      openLoading() {
        const loading = this.$loading({
          lock: true,
          text: this.$t(this.submitText),
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.2)',
          customClass: 'loading_mask'
        });
        this.loading = loading;
      },
      closeLoading() {
        this.loading.close();
      },
      onUserCommand(command) {

        switch(command) {
          case 'changePwd':
            // 修改密码
            this.$router.replace('/change_password');
            break;
          case 'logout':
            // 退出登录
            localStorage.clear();
            sessionStorage.clear();
            this.$router.replace('/login');
            location.reload();
            break;
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .default_page{
    display: flex;
  }
  .top_nav {
    height: 50px;
    display: flex;
    flex-direction: column;
    color: #fff;
    width: 100%;
    justify-content: center;
    box-sizing: border-box;
    font-weight: bold;
    .company_name {
      color: rgb(64, 158, 255);
      font-size: 16px;
    }
    .def_title {
      opacity: 0.6;
      font-size: 12px;
    }
  }
  .left_nav{
    //width: 200px;
    height: 100vh;
    background: $background-color;
    .left_bottom_navs {
      height: calc(100vh - 60px);
      overflow-y: auto;
      overflow-x: hidden;
      &::-webkit-scrollbar {         /*滚动条整体样式*/
        width:8px;
      }
      &::-webkit-scrollbar-thumb {   /*滚动条里面小方块样式*/
        border-radius: 8px;
        -webkit-box-shadow:inset 0 0 5px rgba(151, 151, 151, 1);
        background: #6e86a1;
      }
    }
    .ac_nav{
      background: $base-color;
      color: #fff;
    }
  }
  .not_collapse {
    width: 200px;
  }
  .right_content{
    flex: 1;
    box-sizing: border-box;
    height: 100%;
    overflow-x: auto;
    .breadcrumb-container {
      .leftBarBtn {
        font-size: 18px;
        margin: 0 10px;
      }
      height: 50px;
      overflow: hidden;
      background: #fff;
      -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
      box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    }
    .content-wrapper {
      padding: 10px 20px;
      height: calc(100vh - 50px);
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: auto;
      &::-webkit-scrollbar {         /*滚动条整体样式*/
        width:8px;
        height: 8px;
      }
      &::-webkit-scrollbar-thumb {   /*滚动条里面小方块样式*/
        border-radius: 8px;
        -webkit-box-shadow:inset 0 0 5px rgba(151, 151, 151, 0.2);
        background:rgba(0,0,0,0.1);
        &:hover {
          width: 10px;
        }
      }
      //&::-webkit-scrollbar-track {   /*滚动条里面轨道样式*/
      //  -webkit-box-shadow:inset 0 0 5px rgba(223, 223, 223, 0.2);
      //  border-radius:100px;
      //  background:rgba(0,0,0,0.1);
      //}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/default.vue